import React, { Component } from 'react';
import * as d3 from 'd3';

import ImgFitness from '../images/hobby/Fitness.png'
import ImgNature from '../images/hobby/Nature.png'
import ImgPlay from '../images/hobby/Play.png'
import ImgMusic from '../images/hobby/Music.png'
import ImgEducation from '../images/hobby/Education.png'
import ImgFashion from '../images/hobby/Fashion.png'
import ImgCrown from '../images/crown.png'


import VillagerAvatar from '../components/VillagerAvatar';
import Button from '../components/Button';
import Dialogue from '../components/Dialogue';

import ChartSpecs from '../data/chart_specs';

const unsortedObj = ChartSpecs.chartspecs.colorWheelObjHobby
const sortObject = o => Object.keys(o).sort((a,b)=>a.localeCompare(b)).reduce((r, k) => (r[k] = o[k], r), {})
const colorWheelObj = sortObject(unsortedObj);
var colorWheelArray = Object.keys(colorWheelObj);
var colorRange = Object.values(colorWheelObj);
var margin = ChartSpecs.chartspecs.margin;

class VillagerHobby extends Component {
  constructor(props){
      super(props);
      this.state = {
        chartType: "viewbyAreaH"
      }
      this.svgRef = React.createRef();

      this.allVillagers = this.props.villagers;
      this.getHobbyIcon = this.getHobbyIcon.bind(this);

      this.tierNodes = {};

   }
   componentDidMount() {
     this.svg = d3.select(this.svgRef.current);

     this.tierNodes = d3.groups(this.allVillagers, d => d.tier, d => d.hobby);
     this.tierNodes2 = d3.rollup(this.allVillagers, v => v.length, d => d.tier, d => d.hobby);
     this.tierArray = [...this.tierNodes2.keys()];

     this.drawAreaStackChartH();

   }

   drawStackBarChart(){
     var svg = this.svg,
         chartWidth = this.svgRef.current.clientWidth,
         chartHeight = 430,
         stackKeys = colorWheelArray,
         radius = 40,
         tooltip = d3.select('#tooltip-hobby');


     let tierNodes = this.tierNodes,
          tierNodes2 = this.tierNodes2,
          tierArray = this.tierArray;

     let tableData = Array.from(tierNodes2.entries())
     .map(g => {
       const obj = {};
       obj["tier"] = g[0];
       for (let col of stackKeys) {
         const vals = g[1].get(col);
         //console.log("vals: "+vals);
         obj[col] = !vals ? 0 : vals;
       }
       return obj;
     })
    .sort((a, b) => a["tier"] - b["tier"]);


     chartHeight = tierNodes.length * radius + margin.top + margin.bottom

     const yScale = d3.scaleBand()
           //.domain(tierNodes.map(d => d[0])) //tiers
           .domain(tierArray)
           .range([margin.top, chartHeight - margin.bottom])
           .padding(0.25)

     const xScale= d3.scaleLinear()
                   .range([margin.left, chartWidth - margin.right])


     const colorScale = d3.scaleOrdinal()
                 .domain(colorWheelArray)
                 .range(colorRange)

     const xAxis = g => g
                 .attr("transform", `translate(0,${margin.top+10})`)
                 .call(d3.axisTop(xScale).ticks(chartWidth / 100, "%"))
                 .call(g => g.selectAll(".domain").remove());

     const yAxis = g => g
               .attr("transform", `translate(${margin.left},0)`)
               .call(d3.axisLeft(yScale).tickFormat(function(d,i){ return `T.${d}` }).tickSizeOuter(0))
               .call(g => g.selectAll(".domain").remove())



     const formatPercent = d3.format(".1%");
     const formatValue = x => isNaN(x) ? "N/A" : x.toLocaleString("en")
     /* set up mutiple colli  */
     let basePerRow = 10,
         baseRowWidth = (chartWidth + 0) / (basePerRow + 1);

     const series = d3.stack()
                   .keys(stackKeys)
                   .offset(d3.stackOffsetExpand)
                 (tableData)
                   .map(d => (d.forEach(v => v.key = d.key), d))

     svg.attr("id", 'hobbyChart');
     svg.attr("height", chartHeight);

     svg.append("g")
     .attr("class", 'xaxis')
     .call(xAxis);

     svg.append("g")
     .attr("class", 'yaxis tier-axis no-tick')
     .call(yAxis);

     svg.append("g")
       .selectAll("g")
       .data(series)
       .join("g")
         .attr("fill", d => colorScale(d.key))
       .selectAll("rect")
       .data(d => d)
       .join("rect")
         .attr("x", d => xScale(d[0]))
         .attr("y", (d, i) => yScale(d.data.tier))
         .attr("width", d => xScale(d[1]) - xScale(d[0]))
         .attr("height", yScale.bandwidth())
         .on("mouseenter", function(e,d) {
           const x = xScale(d[0]) + (xScale(d[1]) - xScale(d[0])) / 2;
           const y = yScale(d.data.tier);

           let thisBar = d3.select(this);


           d3.select('#tooltip-hobby')
                       .transition()
                       .duration(200)
                       .style("display", "block");

           d3.select('#tooltip-hobby')
             .html(
               `<p> Tier ${d.data.tier} ${d.key} ${formatPercent(d[1] - d[0])} (${formatValue(d.data[d.key])}) </p>`
             ).style(
                   "transform",
                   `translate(` + `calc( -50% + ${x}px),` + `calc(-100% + ${y}px)` + `)`
                 );

            d3.select(this).transition()
                   .duration(350)
                   .style("stroke", d => colorScale(d.key))

         })
         .on('mouseleave', function() {
           d3.select('#tooltip-hobby')
             .transition()
             .duration(200)
             .style("display", "none")

           d3.select(this)
             .transition()
             .style("stroke", 'none')


         })

   }

   drawAreaStackChart(){
       var svg = this.svg,
           chartWidth = this.svgRef.current.clientWidth,
           chartHeight = 430,
           stackKeys = colorWheelArray,
           radius = 40;


       let tierNodes = this.tierNodes,
            tierNodes2 = this.tierNodes2,
            tierArray = this.tierArray;

       let tableData = Array.from(tierNodes2.entries())
       .map(g => {
         const obj = {};
         obj["tier"] = g[0];
         for (let col of stackKeys) {
           const vals = g[1].get(col);
           //console.log("vals: "+vals);
           obj[col] = !vals ? 0 : vals;
         }
         return obj;
       })
      .sort((a, b) => a["tier"] - b["tier"]);


       chartHeight = tierNodes.length * radius + margin.top + margin.bottom

       const yScale = d3.scaleBand()
             //.domain(tierNodes.map(d => d[0])) //tiers
             .domain(tierArray)
             .range([margin.top, chartHeight - margin.bottom])
             .padding(0.25)

       const xScale= d3.scaleLinear()
                     .range([margin.left, chartWidth - margin.right])


       const colorScale = d3.scaleOrdinal()
                   .domain(colorWheelArray)
                   .range(colorRange)

       const xAxis = g => g
                   .attr("transform", `translate(0,${margin.top+10})`)
                   .call(d3.axisTop(xScale).ticks(chartWidth / 100, "%"))
                   .call(g => g.selectAll(".domain").remove());

       const yAxis = g => g
                 .attr("transform", `translate(${margin.left},0)`)
                 .call(d3.axisLeft(yScale).tickFormat(function(d,i){ return `T.${d}` }).tickSizeOuter(0))
                 .call(g => g.selectAll(".domain").remove())



       const formatPercent = d3.format(".1%");
       const formatValue = x => isNaN(x) ? "N/A" : x.toLocaleString("en")

         // Creating the clone of the array
         let clonetableData = tableData.slice(0);

         const clonetableDataArr = tableData.map(d => ({ ...d}));

         // Extract the array using splice method
         let tableDataExtended = clonetableDataArr.splice(0,tierArray.length);

         const clonetableDataFirst = tableDataExtended[0];
         const clonetableDataLast = tableDataExtended[tierArray.length-1];

         //let tableDataExtended = tableData.slice();

         tableDataExtended.unshift(clonetableDataFirst);
         tableDataExtended.push(clonetableDataLast);

         let newFirst = tableDataExtended[0],
             newLast = tableDataExtended[tableDataExtended.length-1];


       const series = d3.stack()
                     .keys(stackKeys)
                     .offset(d3.stackOffsetExpand)
                   (tableDataExtended)
                     .map(d => (d.forEach(v => v.key = d.key), d))

       svg.attr("id", 'hobbyChart');
       svg.attr("height", chartHeight);

       svg.append("g")
       .attr("class", 'xaxis')
       .call(xAxis);

       svg.append("g")
       .attr("class", 'yaxis tier-axis no-tick')
       .call(yAxis);

       // define the area
       let area = d3.area()
           .x0(d => xScale(d[0]))
           .x1(d => xScale(d[1]))
           .y((d,i) => {
             if(i === 0){
               return yScale.bandwidth()/2 + margin.left/2
             }else if(i === (tableDataExtended.length-1)){
               return  yScale(d.data.tier) + yScale.bandwidth()/2
             }else{
               return  yScale(d.data.tier)
             }
           })
           //.y0(yScale(0))
           //.y(d => yScale(d.data.tier))
           .curve(d3.curveBasis)


       // define the area
       let area2 = d3.area()
           .y(d => yScale(d.data.tier))
           .x0(d => xScale(d[0]))
           .x1(d => xScale(d[1]))
           .curve(d3.curveBasis)

      let layer = svg.append("g")
            .selectAll(".layer")
            .data(series)
           .join("g")
            .attr("class", "layer")
            .attr("transform", `translate(${0}, ${margin.top/2.5})`);

      layer.append("path")
            .attr("class", "area-personality")
            .attr("fill", d => colorScale(d.key))
            .attr("d", area);



     }

   drawAreaStackChartH(){
        var svg = this.svg,
            chartWidth = this.svgRef.current.clientWidth,
            chartHeight = 460,
            stackKeys = colorWheelArray,
            radius = 40;


        let tierNodes = this.tierNodes,
             tierNodes2 = this.tierNodes2,
             tierArray = this.tierArray;

        let tableData = Array.from(tierNodes2.entries())
        .map(g => {
          const obj = {};
          obj["tier"] = g[0];
          for (let col of stackKeys) {
            const vals = g[1].get(col);
            //console.log("vals: "+vals);
            obj[col] = !vals ? 0 : vals;
          }
          return obj;
        })
       .sort((a, b) => a["tier"] - b["tier"]);


        const xScale = d3.scaleBand()
              .domain(tierArray)
              .range([margin.left, chartWidth + margin.right])
              .paddingOuter(0.25)

             // .padding(0.25)

        const yScale= d3.scaleLinear()
                      .range([chartHeight - margin.top, margin.top])
                      // .range([ chartHeight/totalBarGroups - margin.top, margin.top/totalBarGroups])


        const colorScale = d3.scaleOrdinal()
                    .domain(colorWheelArray)
                    .range(colorRange)

        const yAxis = g => g
                    .attr("transform", `translate(${margin.left},0)`)
                    .call(d3.axisLeft(yScale).ticks(chartWidth / 100, "%"))
                    .call(g => g.selectAll(".domain").remove());

        const xAxis = g => g
                  .attr("transform", `translate(${-margin.left/2},${ chartHeight - margin.top/1.25})`)
                   //.attr("transform", `translate(0,${margin.top+10})`)
                  .call(d3.axisBottom(xScale).tickFormat(function(d,i){ return `T.${d}` }).tickSizeOuter(0))
                  .call(g => g.selectAll(".domain").remove())



                const formatPercent = d3.format(".1%");
                const formatValue = x => isNaN(x) ? "N/A" : x.toLocaleString("en")

                  // Creating the clone of the array
                  let clonetableData = tableData.slice(0);

                  const clonetableDataArr = tableData.map(d => ({ ...d}));

                  // Extract the array using splice method
                  let tableDataExtended = clonetableDataArr.splice(0,tierArray.length);

                  const clonetableDataFirst = tableDataExtended[0];
                  const clonetableDataLast = tableDataExtended[tierArray.length-1];

                  //let tableDataExtended = tableData.slice();

                  tableDataExtended.unshift(clonetableDataFirst);
                  tableDataExtended.push(clonetableDataLast);

                  let newFirst = tableDataExtended[0],
                      newLast = tableDataExtended[tableDataExtended.length-1];


                const series = d3.stack()
                              .keys(stackKeys)
                              .offset(d3.stackOffsetExpand)
                            (tableDataExtended)
                              .map(d => (d.forEach(v => v.key = d.key), d))

        svg.attr("id", 'hobbyChart');
        svg.attr("height", chartHeight);

        svg.append("g")
        .attr("class", 'xaxis tier-axis')
        .call(xAxis);

        svg.append("g")
        .attr("class", 'yaxis')
        .call(yAxis);

        // define the area
        let area = d3.area()
            .y0(d => yScale(d[0]))
            .y1(d => yScale(d[1]))
            .x((d,i) => {
              if(i === 0){
                return xScale.bandwidth()/2 + margin.left/2
              }else if(i === (tableDataExtended.length-1)){
                return  xScale(d.data.tier) + xScale.bandwidth()/2
              }else{
                return  xScale(d.data.tier)
              }
            })
            .curve(d3.curveBasis)


       let layer = svg.append("g")
             .selectAll(".layer")
             .data(series)
             .join("g")
             .attr("class", "layer")
             .attr("transform", `translate(${0}, ${0})`);

       layer.append("path")
             .attr("class", "area-hobby")
             .attr("fill", d => colorScale(d.key))
             .attr("d", area);

       layer.append("text")
            .attr("class", "area-label")
            .filter(d => (d.key === 'Nature' || d.key === 'Fitness'))
            .attr("x", d => (d.key === 'Nature')?margin.left*1.5:(chartWidth-margin.left*2))
            .attr("y", d => (d.key === 'Nature')?(yScale(d[0][1])+((yScale(d[0][0]) - yScale(d[0][1]))/2)):(yScale(d[10][1])+((yScale(d[10][0]) - yScale(d[10][1]))/2)) )
            .attr("dy", "0")
            .attr("fill",'#333333')
            .text(d => d.key);

      }

   drawDistributionChart(){
     var svg = this.svg,
         chartWidth = this.svgRef.current.clientWidth,
         chartHeight = 560,
         stackKeys = colorWheelArray,
         //stackKeys = [1,1.5,2,2.5,3],
         radius = 40;

     svg.attr("id", 'hobbyChart');
     svg.attr("height", chartHeight);

     // let allVillagers = this.allVillagers;

      let tierNodes = this.tierNodes,
           tierNodes2 = this.tierNodes2,
           tierArray = this.tierArray;

     let tableData = Array.from(tierNodes2.entries())
     .map(g => {
       const obj = {};
       obj["tier"] = g[0];
       for (let col of stackKeys) {
         const vals = g[1].get(col);
         obj[col] = !vals ? 0 : vals;
       }
       return obj;
     })
    .sort((a, b) => a["tier"] - b["tier"]);

    const yMaxArray = stackKeys.map(score => {
      let max = d3.max(tableData, d => d[score])
      return max;
    });

     const yMax = d3.max(yMaxArray, d => d);

     const totalBarGroups = stackKeys.length;

     const xScale = d3.scaleBand()
                     .domain(tierArray)
                     .range([margin.left, chartWidth - margin.right])
                     //.padding(0.5)

     const yScale = d3.scaleLinear()
                     .domain([ 0, yMax ])
                     .range([ chartHeight/totalBarGroups - margin.top, margin.top/totalBarGroups])

     const xAxis = g => g
                 .attr("transform", `translate(0,${ chartHeight - margin.top/1.5})`)
                 .call(d3.axisBottom(xScale).tickSizeOuter(0))
                 .call(g => g.selectAll(".domain").remove());

     const yAxis = g => g
               .call(d3.axisLeft(yScale).ticks(3).tickSizeOuter(0))
               .call(g => g.selectAll(".domain").remove());

     svg.append("g")
      .attr("class", 'xaxis tier-axis')
      .call(xAxis);

     stackKeys.forEach((hobby, index) => {

       svg.append("g")
       .attr("transform", `translate(${margin.left}, ${margin.top/totalBarGroups + index*(chartHeight/totalBarGroups)})`)
       .call(yAxis);

       svg.append("g")
         .attr('class', `bars-${hobby}`)
         .selectAll('rect')
         .data(tableData)
         .join('rect')
           .attr('class', 'bar')
           .attr('x', d => xScale(d.tier))
           .attr('y', d => yScale(d[hobby]) + margin.top/totalBarGroups + index*(chartHeight/totalBarGroups))
           .attr('width', xScale.bandwidth())
           .attr('height', d => yScale(0) - yScale(d[hobby]))
           //.style('stroke', '#017C74')
           .style('fill', colorWheelObj[hobby])
           .style("opacity", 0.8)
           .append("title")
           .text(d => ` ${hobby} in Tier ${d.tier}, Total: ${d[hobby]}`);

      let barLabels = svg.append("g")
          .attr('class', `bar-label-${hobby}`)
          .attr("transform", `translate(${chartWidth - margin.right/5}, ${margin.top/2 + index*(chartHeight/totalBarGroups)}) rotate(90)`)

      barLabels.append('rect')
            .attr('class', 'bar-label-container')
            .style('stroke', '#017C74')
            .style('fill', 'transparent')
            .attr("width", d => yScale(0) - yScale(yMax))
            .attr("height", d => margin.right/2)

      barLabels.append('text')
            .attr('class', 'bar-label')
            //.attr("transform", "rotate(90)")
            .style("font-size",8)
            //.style('fill', '#ffffff')
            .attr("x", d => margin.right/5)
            .attr('y', d => yScale(yMax))
            .attr("dy", ".35em")
            .text(function(d) { return `${hobby}` });

     });


   }


   getHobbyIcon(hobby){
      switch (hobby) {
        case 'Fitness':
          return ImgFitness
          break;
        case 'Nature':
          return ImgNature
          break;
        case 'Play':
          return ImgPlay
          break;
        case 'Music':
          return ImgMusic
          break;
        case 'Fashion':
          return ImgFashion
          break;
        case 'Education':
          return ImgEducation
          break;
      }

  }

  render() {
    return (
      <div ref={this.props.innerRef}  id={`villager-${this.props.step}`} className="step category-traits">
        <h2 className="title">Villager hobby</h2>
        <p className="paragraph">In addition to personality traits, every villager has one of six hobbies, which influences some of the activities they do while walking around the village. Does a villager’s hobby have anything to do with how popular they are?</p>
        <ul className="chart-key-list long-list hobby-keys">
          {colorWheelArray.map(list => {
              return (
                <li className="hobby-icons" key={list}><span className='card-hobby'  style={{ backgroundColor: `${colorWheelObj[list]}`, backgroundImage : `url(${this.getHobbyIcon(list)})`}}></span><span className="avatar-label">{list}</span></li>
              )
          })}
        </ul>

        <div className="svg-wrapper">
          <div id="tooltip-hobby"  className="bar-tooltip"></div>
          <svg ref={this.svgRef} width="100%"></svg>
        </div>
        <p className="paragraph"> Looking at the chart, villagers with a <b>Nature</b> hobby cluster significantly more in the higher popularity tiers. Their numbers decrease from Tier 1 to Tier 10. Although not as strong of a pattern, the distribution of <b>Play</b> hobbies also peaks in the upper tiers and drops down in Tier 10.  </p>
        <p className="paragraph"> On the opposite end, villagers with a <b>Fitness</b> hobby cluster significantly more in the lower popularity tiers, and their numbers increase from Tier 1 to Tier 10. Although not as strong of a pattern, the distribution of <b>Fashion</b> hobbies also appears to favor the bottom tiers. </p>
        <Dialogue title="Summary" type="regular">
          <p className="paragraph"> Villagers with a <b>Nature</b> or <b>Play</b> hobby are tend to be more popular, while villagers with a <b>Fitness</b> or <b>Fashion</b> hobby tend to be less popular. </p>
        </Dialogue>
      </div>
    )
  }
}
export default VillagerHobby;
